import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance } from 'intact-vue-next';
import { request } from './ajaxUploader';
import { isFunction } from 'intact-shared';
export var UploadFileStatus;
(function (UploadFileStatus) {
  UploadFileStatus[UploadFileStatus["Done"] = 0] = "Done";
  UploadFileStatus[UploadFileStatus["Ready"] = 1] = "Ready";
  UploadFileStatus[UploadFileStatus["NotReady"] = 2] = "NotReady";
  UploadFileStatus[UploadFileStatus["Uploading"] = 3] = "Uploading";
  UploadFileStatus[UploadFileStatus["Error"] = 4] = "Error";
})(UploadFileStatus || (UploadFileStatus = {}));
export function useUpload() {
  var instance = useInstance();
  function upload(_x) {
    return _upload.apply(this, arguments);
  }
  function _upload() {
    _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var _extends2;
      var beforeUpload, files, shouldUpload, newFiles, index, _instance$get, data, action, headers, name, withCredentials;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            beforeUpload = instance.get('beforeUpload');
            files = instance.get('files');
            shouldUpload = true;
            if (!beforeUpload) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return beforeUpload(file, files);
          case 6:
            shouldUpload = _context.sent;
          case 7:
            if (shouldUpload) {
              _context.next = 12;
              break;
            }
            newFiles = _sliceInstanceProperty(files).call(files, 0);
            index = newFiles.indexOf(file);
            if (index > -1) {
              _spliceInstanceProperty(newFiles).call(newFiles, index, 1);
              instance.set({
                files: newFiles
              });
            }
            return _context.abrupt("return", false);
          case 12:
            _instance$get = instance.get(), data = _instance$get.data, action = _instance$get.action, headers = _instance$get.headers, name = _instance$get.name, withCredentials = _instance$get.withCredentials;
            file.request = request({
              action: action,
              headers: headers,
              withCredentials: withCredentials,
              data: _extends((_extends2 = {}, _extends2[name || file.name] = file.raw, _extends2), isFunction(data) ? data(file) : data || {}),
              onProgress: function onProgress(e, percent, xhr) {
                _onProgress(e, percent, file, xhr);
              },
              onError: function onError(e) {
                _onError(e, file);
              },
              onSuccess: function onSuccess(res, xhr) {
                _onSuccess(res, file, xhr);
              }
            });
            return _context.abrupt("return", true);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _upload.apply(this, arguments);
  }
  function _onProgress(e, percent, file, xhr) {
    file.status = UploadFileStatus.Uploading;
    file.percent = percent;
    instance.forceUpdate();
    instance.trigger('progress', e, xhr, file, instance.get('files'));
  }
  function _onError(e, file) {
    file.status = UploadFileStatus.Error;
    instance.forceUpdate();
    instance.trigger('error', e, file, instance.get('files'));
  }
  function _onSuccess(res, file, xhr) {
    file.status = UploadFileStatus.Done;
    instance.forceUpdate();
    instance.trigger('success', res, xhr, file, instance.get('files'));
  }
  return upload;
}